module.exports = __webpack_public_path__ + "static/media/sq-AL.2d863ad5.md";